import React from "react"
import { View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { IconImageM } from "@common/components/icons/IconsM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { calculateTimerColor } from "../../execute/TimerContainer"
import { DoneChip } from "../../read/DoneChip"

/** `subtitleExtra` : à la suite du chapitre, à sa taille (le « Quiz d'abord » du masteur). */
const ActivityItemInfo = ({ item, schoolSubject, status, statusActivity, subtitleExtra = null }) => {
    const showStatusBadge =
        (status ?? statusActivity) && (status ?? statusActivity) !== "todo"
    const timerPercentage =
        item?.duration && item?.estimated_duration
            ? (item.duration * 100) / (item.estimated_duration * 60)
            : 0
    const timerColor = item?.duration
        ? calculateTimerColor(timerPercentage, "finished")
        : theme.colors.light

    return (
        <View
            style={{
                flexDirection: "row",
                alignItems: "center",
                flex: 1,
                marginRight: 10,
            }}
        >
            {/* Left: Title + Chapter */}
            <View style={{ flex: 1 }}>
                <TextM
                    fontWeight="SemiBold"
                    fontSize={14}
                    numberOfLines={1}
                >
                    {item?.material?.title ?? item?.title}
                </TextM>
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginTop: 2,
                    }}
                >
                    <IconImageM
                        uri={schoolSubject?.icon}
                        width={9}
                        style={{ marginRight: 4 }}
                    />
                    <TextM
                        fontWeight="Light"
                        color={schoolSubject?.color}
                        fontSize={9}
                        numberOfLines={1}
                        style={{ flexShrink: 1 }}
                    >
                        {item?.student_chapter?.chapter?.name
                            ? item?.student_chapter?.chapter?.name
                            : schoolSubject?.name}
                    </TextM>
                    {subtitleExtra}
                </View>
            </View>
            {/* Right: Status badge + Duration (vertically centered) */}
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginLeft: 10,
                }}
            >
                {showStatusBadge && (
                    <DoneChip
                        count={0}
                        status={status ?? statusActivity}
                        style={{ marginRight: 6 }}
                        noText
                    />
                )}
                {item?.estimated_duration && (
                    <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                        }}
                    >
                        <FontAwesome5
                            name="stopwatch"
                            solid
                            size={12}
                            color={timerColor}
                            style={{ marginRight: 4 }}
                        />
                        <TextM
                            fontSize={10}
                            fontWeight="SemiBold"
                            color={theme.colors.light}
                        >
                            {item?.duration && (
                                <TextM
                                    fontSize={12}
                                    fontWeight="Bold"
                                    color={timerColor}
                                >
                                    {Math.floor(item.duration / 60)}
                                </TextM>
                            )}
                            {item?.duration ? " / " : "- / "}
                            {item?.estimated_duration} min
                        </TextM>
                    </View>
                )}
            </View>
        </View>
    )
}

export default ActivityItemInfo
